import { render, staticRenderFns } from "./reportTbale.vue?vue&type=template&id=47ab0ad2"
import script from "./reportTbale.vue?vue&type=script&lang=js"
export * from "./reportTbale.vue?vue&type=script&lang=js"
import style0 from "./reportTbale.vue?vue&type=style&index=0&id=47ab0ad2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports